import { render, staticRenderFns } from "./prot.vue?vue&type=template&id=5b130460&scoped=true&"
import script from "./prot.vue?vue&type=script&lang=js&"
export * from "./prot.vue?vue&type=script&lang=js&"
import style0 from "./prot.vue?vue&type=style&index=0&id=5b130460&lang=scss&scoped=true&"
import style1 from "./prot.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b130460",
  null
  
)

export default component.exports